import { Navigate } from 'react-router-dom'
import SidebarLayout from './SidebarLayout/sidebar-layout'
import { ROUTES } from '@/config/routes'

import { useCurrentUser } from '@/features/auth/state/auth'

const AuthenticatedLayout = ({ children }: { children: JSX.Element }) => {
  const user = useCurrentUser()

  if (!user) {
    return <Navigate to={ROUTES.SIGNIN.path} />
  }

  return <SidebarLayout>{children}</SidebarLayout>
}

export default AuthenticatedLayout
